import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['scrap_id', 'ID'],
  ['collection_id', 'ID'],
]);
export default function UPSERT_BOOKMARK() {
  return gql`
    mutation UpsertBookmark(${parametersTypeString}) {
      upsertBookmark(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
